import { useCallback } from 'react';

import { useAssignLineToPalletMutation } from '../api/palletsApi';
import type { AssignLineToPalletRequest, AssignLineToPalletParams } from '../api/palletsApi';

export interface UseAssignLineToPalletOptions {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export const useAssignLineToPallet = (options?: UseAssignLineToPalletOptions) => {
  const [assignLineToPallet, { isLoading, isSuccess, isError, error }] = useAssignLineToPalletMutation();

  const handleAssign = useCallback(
    async (params: AssignLineToPalletParams, request: AssignLineToPalletRequest) => {
      try {
        await assignLineToPallet({
          ...params,
          ...request
        }).unwrap();
        options?.onSuccess?.();
      } catch (error) {
        options?.onError?.(error);
        throw error;
      }
    },
    [assignLineToPallet, options]
  );

  return {
    assignLineToPallet: handleAssign,
    isLoading,
    isSuccess,
    isError,
    error
  };
};
